import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { CalendarBlockProps, CalendarInteractions } from './partials/CalendarInteractions';
import { CalendarDefaultView } from './views/CalendarDefaultView';

function Calendar({ views, activeView = 'default' }: CalendarBlockProps) {
  const { editModeInfo } = useAppContext();
  const { active } = editModeInfo;
  switch (active) {
    case true:
      // EditMode
      return <CalendarInteractions views={views} activeView={activeView} />;
    default:
      // LiveMode:
      return <CalendarDefaultView {...views.default} />;
  }
}

export const CalendarBlock = asFetchableBlock(Calendar, BlockType.calendar);
export type CalendarBlock = ComponentProps<typeof CalendarBlock>;
